module.exports = __webpack_public_path__ + "img/profile.2b12b430.png";